/**
 * 门店树
  POST /baseinfo/shop/tree
  接口ID：188322448
  接口地址：https://app.apifox.com/link/project/4556737/apis/api-188322448
 */
import { useFetch } from "../../../hooks";
export var useApiBaseinfoShopTree = function useApiBaseinfoShopTree() {
  var _useFetch = useFetch(),
    post = _useFetch.post;
  var DEFAULT_URL = '/baseinfo/shop/tree';
  return function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_URL;
    var params = arguments.length > 1 ? arguments[1] : undefined;
    return post({
      url: url === '' ? DEFAULT_URL : url,
      data: params
    }).then(function (res) {
      if (res.code === 0 && Array.isArray(res.data)) {
        return res.data;
      }
      return [];
    }).catch(function (error) {
      return error.response.data;
    });
  };
};